import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useMatch } from "@/hooks/useMatch";
import { MatchSection, RegistrationSection, DraftSection, TeamsSection, ResultSection } from "@/components/admin/MatchSections";
import { MotmSection, SettingsSection, UsersSection } from "@/components/admin/GlobalSections";
import { fmtDate } from "@/lib/football";

const TABS = [["match", "Match"], ["inscriptions", "Inscriptions"], ["draft", "Capitaines & Draft"], ["equipes", "Équipes"],
  ["resultat", "Résultat"], ["motm", "Homme du Match"], ["parametres", "Paramètres"], ["joueurs", "Joueurs"]];

export default function Admin() {
  const { data, act } = useMatch("current", 15000);
  const [tab, setTab] = useState("match");
  const sections = { match: MatchSection, inscriptions: RegistrationSection, draft: DraftSection, equipes: TeamsSection, resultat: ResultSection };
  const S = sections[tab];
  return (
    <div data-testid="admin-page" className="space-y-4">
      <Link to="/profil" className="inline-flex items-center gap-1.5 text-sm text-slate-500"><ArrowLeft className="w-4 h-4" /> Profil</Link>
      <div>
        <h1 className="font-display text-2xl font-extrabold">ADMINISTRATION</h1>
        {data && <p className="text-xs text-slate-500" data-testid="admin-current-match">Match en cours : {fmtDate(data.match.date)} · {data.match.time} · {data.match.location}</p>}
      </div>
      <div className="-mx-4 px-4 flex gap-2 overflow-x-auto no-scrollbar pb-1">
        {TABS.map(([k, l]) => (
          <button key={k} data-testid={`admin-tab-${k}`} onClick={() => setTab(k)}
            className={`whitespace-nowrap rounded-full px-3.5 py-2 text-xs font-bold border ${tab === k ? "bg-cyan-400 text-zinc-950 border-cyan-300" : "bg-white shadow-sm text-slate-600 border-slate-200"}`}>{l}</button>
        ))}
      </div>
      {S && data && <S key={data.match.id} data={data} act={act} />}
      {tab === "motm" && <MotmSection />}
      {tab === "parametres" && <SettingsSection />}
      {tab === "joueurs" && <UsersSection />}
    </div>
  );
}
